import { Attachment, Document, Id, Identifiable } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";

const ENDPOINTS = {
  TASK: "/tasks/{{uuid}}/attachments",
  LIST: "/activities/{{uuid}}/attachments",
  EVENT: "/events/{{uuid}}/attachments",
  MILESTONE: "/milestones/{{uuid}}/attachments",
  EXPENSE: "/expenses/{{uuid}}/attachments",
};
function attachDocumentsToElement(httpClient: HttpClient) {
  return (
    projectId: Id,
    elementType: "TASK" | "LIST" | "EVENT" | "MILESTONE" | "EXPENSE",
    elementId: Id,
    documents: Identifiable<Document>[],
  ) => {
    const endpoint = ENDPOINTS[elementType].replace("{{uuid}}", elementId);
    return Promise.all(
      documents.map((document) => {
        return httpClient.sendHttpRequest<Identifiable<Attachment>>({
          endpoint,
          method: HttpMethods.POST,
          data: {
            projectUuid: projectId,
            attachmentType: document.type.toUpperCase(),
            attachedEntityUuid: document.uuid,
          },
        });
      }),
    ).then(() => ({
      projectId,
      elementId,
      elementType,
      documents,
    }));
  };
}

export { attachDocumentsToElement };
